import { render, staticRenderFns } from "./ResolutionBuilder.vue?vue&type=template&id=597e35ca&"
import script from "./ResolutionBuilder.vue?vue&type=script&lang=js&"
export * from "./ResolutionBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports